HPeriodSelector.$inject = ['$scope', '$filter'];

function HPeriodSelector($scope, $filter) {
    const self = this;

    const defaultWeeksCountOptions = [
        {id: 'FOUR', label: $filter('translate')('4 weeks'), value: 4},
        {id: 'FIVE', label: $filter('translate')('5 weeks'), value: 5},
        {id: 'SIX', label: $filter('translate')('6 weeks'), value: 6},
    ];

    const getNewRange = (date, weekCount) => {
        const weekStartDate = getWeekStart(date, self.startDayOfWeek);
        const weekEndDate = weekStartDate.clone().add(6, 'days');
        let monthWeekEndDate = weekStartDate.clone().add(weekCount, 'week').subtract(1, 'day');
        return {
            from: weekStartDate,
            selectedDate: date.clone(),
            to: weekEndDate,
            monthTo: monthWeekEndDate,
        };
    };

    self.formatRangeDisplay = (range) => {
        if (!range?.from) {
            return '';
        }
        const daysInWeeksNumber = self.selectedWeeksCount.value * 7;
        const monthTo = range?.monthTo ?? range.from.clone().add(daysInWeeksNumber - 1, 'days');
        return `${range.from.format('MMM DD')} - ${monthTo.format('MMM DD, YYYY')}`;
    };

    self.onWeeksCountChange = (newWeeksCount) => {
        self.selectedWeeksCount = newWeeksCount;
        if (self.selectedRange) {
            self.selectedRange = getNewRange(self.selectedRange.from.clone(), newWeeksCount.value);
        }
    };

    self.onWeekSelectionChange = (event) => {
        const weekRange = event.weekRange;
        self.selectedRange = getNewRange(weekRange.from.clone(), self.selectedWeeksCount.value);
    };

    self.applySelectedRange = () => {
        if (!self.selectedRange) {
            return;
        }
        self.appliedRange = angular.copy(self.selectedRange);
        const $event = {
            range: self.selectedRange,
            weeksCount: self.selectedWeeksCount,
        };
        self.onRangeApplied({$event});
    };

    const init = () => {
        if (!self.startDayOfWeek) {
            console.error('start Day Of Week is required');
            return;
        }

        self.weeksCountOptions = Array.isArray(self.weeksCountOptions) && self.weeksCountOptions.length
            ? self.weeksCountOptions
            : defaultWeeksCountOptions;

        self.selectedWeeksCount = self.weeksCountOptions[0];

        const currentWeek = getWeekStart(
            moment().startOf('day'),
            self.startDayOfWeek
        );
        self.selectedRange = getNewRange(currentWeek, self.selectedWeeksCount.value);
        self.appliedRange = angular.copy(self.selectedRange);
    };

    self.$onInit = () => {
        init();
    };
}

export const HPeriodSelectorComponentOptions = {
    bindings: {
        startDayOfWeek: '<',
        onRangeApplied: '&',
        weeksCountOptions: '<?',
    },
    controller: HPeriodSelector,
    controllerAs: '$ctrl',
    templateUrl: '../hmodules/components/h-period-selector/h-period-selector.component.ng.html'
};